
const capitalizeString = value => {
    return value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });
};

export const getGroupsToDropdownFilter = (installationsTags = []) => {
    let groupsTags = [];
    installationsTags.forEach(tag => {
        if (tag.source === "group"){
            groupsTags.push({...tag});
        }
    })

    if (groupsTags.length === 0) {
        return null;
    }

    return {
        id: "groups",
        label: "Groups",
        i18n: "tags.installation_groups",
        options: [
            {
                type: "tags",
                variable: "groups",
                options: [...groupsTags.map(tag => {
                    return {
                        id: tag.idTag.toString(),
                        label: capitalizeString(tag.label.toString()),
                        value: false,
                        variable: tag.idTag.toString(),
                    }
                })],
            },
        ]
    }
}

export const getTagsToDropdownFilter = (installationsTags = []) => {
    let userTags = [];
    installationsTags.forEach(tag => {
        if (tag.source === "user"){
            userTags.push({...tag});
        }
    })

    if (userTags.length === 0) {
        return null;
    }

    return {
        id: "tags",
        label: "Tags",
        i18n: "tags.tags",
        i18nFallback: "Tags",
        options: [
            {
                type: "tags",
                variable: "tags",
                options: [...userTags.map(tag => {
                    return {
                        id: tag.idTag.toString(),
                        label: capitalizeString(tag.label.toString()),
                        value: false,
                        variable: tag.idTag.toString(),
                    }
                })],
            },
        ]
    }
}

export const getAlarmsToDropdownFilter = (alarmTags = [])=>{
    if (alarmTags.length === 0) {
        return null;
    }

    return {
        id: "alarm",
        label: "Alarms",
        i18n: "installationoverview.alarm",
        options: [
            {
                type: "tags",
                variable: "tags",
                label: "Types",
                i18n: "tags.alarm_types",
                options: [
                    ...alarmTags
                    .sort((alarmA, alarmB) => alarmA.toString().localeCompare(alarmB.toString()))
                    .map(alarm => {
                    return {
                        id: alarm.toString(),
                        label: capitalizeString(alarm.toString()),
                        value: false,
                        variable: alarm.toString(),
                    }
                })],
            }
        ]
    }
}

export const getTeamsToDropdownFilter = (installationsTags = [])=>{
    let teams = [];
    installationsTags.forEach(tag => {
        if (tag.source === "team"){
            teams.push({...tag});
        }
    })

    if (teams.length === 0) {
        return null;
    }

    return {
        id: "teams",
        label:  "Teams",
        i18n: "tags.user_teams",
        options: [
            {
                type: "tags",
                variable: "team",
                options: [...teams.map(tag => {
                    return {
                        id: tag.idTag.toString(),
                        label: capitalizeString(tag.label.toString()),
                        value: false,
                        variable: tag.idTag.toString(),
                    }
                })],
            }
        ]
    }
}
